/**
 * Wraps a value in a promise if required
 * @param value
 */
export default async function ensurePromise(awaitable) {
    return await awaitable;
}
